import { InternalMessageResponse } from "features/CenterContent/RoleContent/InternalMessage/schema/responseSchema";
import { DropsBadge } from "shared/components/Spor";

type RelatedEventInfoProps = {
  event: InternalMessageResponse;
};

const RelatedEventInfo = ({ event }: RelatedEventInfoProps) => {
  const relatedEventDetails = event?.relatedEventDetails;

  if (!relatedEventDetails) return null;

  switch (relatedEventDetails.category) {
    case "TRAIN": {
      if (!relatedEventDetails.trainIdentifier?.identifier) return null;

      return (
        <DropsBadge semantics="info">
          {`${relatedEventDetails.trainIdentifier.identifier} / ${relatedEventDetails.lineNumber || "-"}`}
        </DropsBadge>
      );
    }

    case "INFRASTRUCTURE":
      return relatedEventDetails.stretchName ? (
        <DropsBadge semantics="neutral">
          {relatedEventDetails.stretchName}
        </DropsBadge>
      ) : null;

    case "STATION": {
      const { affectedStopNames } = relatedEventDetails;
      if (!affectedStopNames?.length) return null;

      const firstStation = affectedStopNames[0];
      if (!firstStation) return null;

      const lastStation =
        affectedStopNames.length > 1
          ? affectedStopNames[affectedStopNames.length - 1]
          : null;

      return (
        <DropsBadge semantics="neutral">
          {lastStation ? `${firstStation} — ${lastStation}` : firstStation}
        </DropsBadge>
      );
    }

    case "GLOBAL":
      return <DropsBadge semantics="neutral">Global</DropsBadge>;
  }
};

export default RelatedEventInfo;
